import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import RootState from "./state";

import userModule from "./modules/user";
import billingModule from "./modules/billing";
import novelModule from "./modules/novel";
import novelThemeModule from "./modules/novelTheme";
import manuscriptModule from "./modules/manuscript";
import memoModule from "./modules/memo";
import sharedLinkModule from "./modules/sharedLink";
import plotModule from "./modules/plot";
import characterModule from "./modules/character";
import worldViewModule from "./modules/worldView";
import timelineModule from "./modules/timeline";
import tutorialModule from "./modules/tutorial";
import materialModule from "./modules/material";
import nolaNovelModule from "./modules/nolaNovel";
import correlationModule from "./modules/correlation";
import generalModule from "./modules/general";
import proofreadingModule from "./modules/proofreading";
import writingDataModule from "./modules/writingData";
import nolaContestModule from "./modules/nolaContest";
import manuscriptAnalysisModule from "./modules/manuscriptAnalysis";
import notificationModule from "./modules/notification";
import writerTypeIndicatorModule from "./modules/writerTypeIndicator";
import { createWriterTypeResultModule } from "./modules/writerTypeResult";
import assistNavigationModule from "./modules/assistNavigation";
import assistSelectManuscriptModule from "./modules/assistSelectManuscript";
import assistantCatModule from "./modules/assistantCat";
import fishModule from "./modules/fish";
import { createAssistHistoryModule } from "./modules/assistHistory";
import novelGroupModule from "./modules/novelGroup";
import properNounModule from "./modules/properNoun";
import recentlyEditedManuscriptsModule from "./modules/recentlyEditedManuscripts";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store<RootState>({
  state: {},
  modules: {
    userModule,
    billingModule,
    novelModule,
    novelThemeModule,
    manuscriptModule,
    memoModule,
    sharedLinkModule,
    plotModule,
    characterModule,
    worldViewModule,
    timelineModule,
    tutorialModule,
    materialModule,
    nolaNovelModule,
    correlationModule,
    generalModule,
    proofreadingModule,
    writingDataModule,
    nolaContestModule,
    manuscriptAnalysisModule,
    notificationModule,
    writerTypeIndicatorModule,
    writerTypeResultModule: createWriterTypeResultModule(),
    assistNavigationModule,
    assistSelectManuscriptModule,
    assistantCatModule,
    fishModule,
    assistHistory: createAssistHistoryModule(),
    novelGroupModule,
    properNounModule,
    recentlyEditedManuscriptsModule,
  },
  strict: debug,
  plugins: [
    // TODO: 今後ログアウトしたときを考慮すること
    createPersistedState({
      storage: window.sessionStorage,
      // manuscriptModule の本文ロード関連state（editingManuscriptKeys等）は
      // 「現在マウント中のエディタ」に紐づく実行時限定の状態であり、ページリロードをまたいで
      // 永続化されるべきではない。永続化されたままだと、beforeDestroyが走らない形での
      // 離脱（ハードリロード等）で editingManuscriptKeys に原稿keyが残り続け、
      // 次回そのURLに直接アクセスした際に本文取得が誤ってブロックされ続けるバグになる。
      reducer: (state: any) => ({
        ...state,
        manuscriptModule: {
          ...state.manuscriptModule,
          editingManuscriptKeys: [],
          contentLoadState: "idle",
          // 本文自体（content/contentLoaded/contentStatus）もリロードをまたいで永続化すると、
          // initializeを経ない画面への直接アクセス時にcontentLoaded: trueによりAPI再取得が
          // スキップされ、古い本文で編集・保存し得るため未取得状態にリセットする。
          // （キーごと削除すると Manuscript 型が保証する content: string の前提が崩れ、
          // リロード直後の initialize 完了前レンダリングで content.match 等が undefined 例外を起こす）
          manuscriptList: (state.manuscriptModule?.manuscriptList ?? []).map((manuscript: any) => ({
            ...manuscript,
            content: "",
            contentLoaded: false,
            contentStatus: undefined,
          })),
        },
      }),
    }),
  ],
});
